// react imports
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MDBContainer } from "mdb-react-ui-kit";
import tovabb from "../assets/media/icons/tovabb nyil.svg";
import muster_image from "../assets/media/images/muster image.png";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

const NepmesepontPage = (props) => {
    const navigate = useNavigate();

    const [direction, setDirection] = useState(window.outerWidth);

    const { infopages } = useSelector((state) => state);

    useEffect(() => {
        setTimeout(
            () =>
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                }),
            100
        );
    }, []);
    const handleWindowSizeChange = () => {
        setDirection(window.visualViewport.width);
    };

    useEffect(() => {
        window.visualViewport.addEventListener("resize", handleWindowSizeChange);
        handleWindowSizeChange();
        return () => {
            window.visualViewport.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    return (
        <>
            <Helmet>
                <title>Népmesepont - A Vértes Agorája</title>
            </Helmet>
            <section className="nepmese-map-section" id="kapcsolat-map-section">
                <div style={{ position: `fixed`, left: `calc(50% + (1038px * 0.2))`, right: 0, top: 0, bottom: 0, backgroundColor: `#F8FAFF` }} />
                <MDBContainer style={{ maxWidth: "1038px" }} className="nepmese-container p-0">
                    <div className="kapcsolat-map-div">
                        <div className="one-col-div pb-4" style={{ width: `100%` }}>
                            <div className="navigate-div">
                                <div>
                                    <button
                                        onClick={() => {
                                            navigate("/home");
                                        }}>
                                        Főoldal
                                    </button>
                                    <img src={tovabb} alt="tovább nyíl" />
                                </div>
                                <div>
                                    <button>Népmesepont</button>
                                </div>
                            </div>
                            <div className="nepmesepont">
                                <h1>Népmesepont</h1>
                                <h2>Ez a nap más, mint a többi...</h2>
                                <div className="description">
                                    Mi is jól tudjuk! Ezért kínálunk új, mesés szolgáltatást: tematikus születésnapi zsúrokat. Lovagkaland,
                                    Tündérmóka, Virgonc és Csudajó parti várja a gyerekeket Tatabányán, a NépmesePontban.
                                </div>
                                <div className="description">
                                    Az ünnepelt és a meghívottak a vidám, jelmezes játékok, a kincskeresés, a csapatversenyek vagy akár egy titkos
                                    kaland élményével gazdagodhatnak, s ajándékokkal térhetnek haza. Nem utolsó sorban, a szülőknek sem kell
                                    aggódniuk, hogy az önfeledt játék egy szőnyegen hagyott, makacs tortanyomban végződik. Az ünnepelt barátaival
                                    tölthet felhőtlen két órát, a szülők pedig addig kimenőt kapnak.
                                </div>
                                <div className="description">S hogy mit rejtenek az egyes programok?</div>
                                <div className="description">
                                    A <b>LOVAGKALAND</b> során megelevenedik egy középkori lovagi udvar, ahol különböző - erőt, rátermettséget,
                                    ügyességet, furfangot kívánó - próba teljesítésével jutnak el a lovagi várba, hogy megleljék a kincset a résztvevő
                                    gyerekek.
                                </div>
                                <div className="description">
                                    A <b>TÜNDÉRMÓKA</b> varázsútra invitálja az ünneplők seregét, amelynek végén, a kalandos próbák után a
                                    Varázshegyen felköszönthetik a születésnapos tündérkirálylányt.
                                </div>
                                <div className="description">
                                    A <b>VIRGONC</b> szülinap a szuperaktív gyerekek ünnepe. Versenyek, erőfitogtatás: kötélhúzás, célba dobás,
                                    mocsárjárás, egyensúlyozás gondoskodik a kimerítően jó hangulatról.
                                </div>
                                <div className="description">
                                    A <b>CSUDAJÓ PARTI</b> azoknak való, akik szeretik a meglepetéseket. Váratlan kalandok, őrületes játékok, móka és
                                    kacagás garantálja az emlékezetes szülinapi élményt.
                                </div>
                                <img src={muster_image} alt="muster kép" />
                                <h2>Információ a szülőknek</h2>
                                <div className="description" style={{ textDecoration: "underline" }}>
                                    Az alapcsomag tartalma:{" "}
                                </div>
                                <ul className="description">
                                    <li>A tematikus programot megvalósító animátor, meghívó, szörp, dekoráció, jelmez, fényképek a zsúrról</li>
                                    <li>Plusz szolgáltatás: torta és/vagy pizza </li>
                                    <li>Választható időpontok: szombat-vasárnap, 10:00-12:00 vagy 15:00-17:00 h között </li>
                                    <li>Korosztály: 5-12 évesek </li>
                                    <li>Létszám: 8-15 fő </li>
                                </ul>
                                <div className="description" style={{ textDecoration: "underline" }}>
                                    Díjbefizetés a zsúr előtt legkésőbb 15 nappal, a következő módokon lehetséges:
                                </div>
                                <ul className="description">
                                    <li>Készpénzben, a helyszínen.</li>
                                    <li>Átutalással</li>
                                    <li>
                                        Bankkártyával és SZÉP kártyával (A Vértes Agorája jegypénztárában). Ebben az esetben, kérjük, feltétlenül
                                        őrizze meg a fizetési bizonylatot! A kártyaelfogadásról bővebben{" "}
                                        <a href="https://avertesagoraja.hu/blog/2017/01/01/utalvany-es-kartyaelfogadas/">ITT</a> tájékozódhat.
                                    </li>
                                </ul>
                                <div className="description" style={{ textDecoration: "underline" }}>
                                    Lemondás
                                </div>
                                <div className="description">
                                    A foglalás lemondására legkésőbb három nappal a választott időpont előtt van lehetőség.
                                </div>
                                <div className="description" style={{ textDecoration: "underline" }}>
                                    A foglalás menete:
                                </div>
                                <div className="description">
                                    Kérjük, a választott időpont előtt minimum három héttel korábban jelentkezzenek! <br />A foglalás jelentkezési
                                    sorrendben történik és visszaigazolás után válik aktívvá. A visszaigazolást minden esetben két munkanapon belül
                                    megtesszük.
                                </div>
                                <div className="description" style={{ textDecoration: "underline" }}>
                                    Jelentkezés: (munkanapokon, 8:00-16:00 h):
                                </div>
                                <div className="description">
                                    Szűcs Orsolya +36 70 683-5018 |{" "}
                                    <a href={"mailto:szulinap@avertesagoraja.hu"} style={{ textDecoration: "underline" }}>
                                        szulinap@avertesagoraja.hu
                                    </a>
                                </div>
                                {infopages?.filter((k) => k.title === "Adatkezelési tájékoztatók").length > 0 && (
                                    <div className="description">
                                        Az adatvételmi tájékoztató
                                        <a
                                        href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate("/infosfooldal/" + infopages.filter((k) => k.title === "Adatkezelési tájékoztatók")[0]?.id);
                                            }}>
                                            {" "}
                                            Itt{" "}
                                        </a>
                                        érhető el.
                                    </div>
                                )}
                                <div className="loadmore-div">
                                    <button
                                        className="muster-button kiemelt"
                                        onClick={() =>
                                            window.open(
                                                "https://docs.google.com/forms/d/14B7IhmTIyqkNhOcWzS4PcZNIZ-eIa_gsidB1xdmaHqY/viewform?pli=1&pli=1&edit_requested=true",
                                                "_blank"
                                            )
                                        }>
                                        <span className="button-text">Online foglalás</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </MDBContainer>
            </section>
        </>
    );
};

export default NepmesepontPage;
